import { render, staticRenderFns } from "./VaSliderColorPicker.vue?vue&type=template&id=ef0c203e&"
import script from "./VaSliderColorPicker.vue?vue&type=script&lang=js&"
export * from "./VaSliderColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./VaSliderColorPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports